import React from "react";

export default function About() {
  return (
    <div
      name="about"
      id="about"
      className="w-full h-screen bg-[#0a192f] text-gray-300"
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className=" py-16 rounded-md bg-cyan-800 flex flex-col justify-center items-center w-4/6">
          <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8 mb-4">
            <div className="sm:text-right pb-8 pl-4">
              <p className="text-4xl font-bold inline border-b-4 border-cyan-500">
                About
              </p>
            </div>
            <div></div>
          </div>
          <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
            <div className="sm:text-right text-4xl font-bold">
              <p>
                Hi. I'm Adithya, nice to meet you. Please take a look around.
              </p>
            </div>
            <div>
              <p>
                {" "}
                As a highly skilled professional experienced in React.js,
                FastAPI, MongoDB, Node.js, and RESTful API development, I have a
                strong foundation in building responsive and scalable web
                applications. Additionally, my expertise in deep learning
                techniques and proficiency in popular libraries such as NumPy,
                Matplotlib, Scikit-learn, and Pandas enhance my comprehensive
                skill set. I am committed to continuous learning and growth.
              </p>
              <h3 className="text-2xl font-bold mt-4">Experience</h3>
              <ul>
                <li>
                  <strong>Metapher Analytics</strong> - Full Stack Developer
                  (Bangalore, India)
                </li>
                <li>
                  <strong>CodeClause</strong> - Data Science Intern
                  (Remote,India)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
